<template>
  <div v-if="contents.status">
    <!--begin::Container-->
    <div id="kt_content_container" class="container-xxl my-5">
      <!--begin::Hero card-->
      <div class="card mb-12 shadow-sm">
        <!--begin::Hero body-->
        <div class="card-body flex-column p-5 mb-5">
          <!--begin::Hero content-->
          <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center h-lg-300px p-5 p-lg-15 overlay-wrapper gap-10"
          >
            <!--begin::Wrapper-->
            <div
              class="d-flex flex-column align-items-start justift-content-center flex-equal me-5 order-1 order-md-0"
            >
              <!--begin::Title-->
              <h1 class="fw-bolder fs-4 fs-lg-1 text-gray-800 mb-5 mb-lg-5">
                {{ contents.data.page.locale.title }}
              </h1>
              <!--end::Title-->
              <!--begin::Input group-->
              <div class="position-relative w-100 mb-5 mb-lg-10">
                <span class="text-gray-600 fs-6">{{
                  contents.data.page.locale.subTitle
                }}</span>
              </div>
              <!--end::Input group-->
              <!--begin::Action-->
              <a
                v-if="$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47'"
                href="#"
                class="btn btn-primary fw-bolder fs-5"
                @click="setModalConfigs('create')"
                ><i
                  class="me-2 fs-4"
                  :class="`${contents.data.page.setting.buttonIcon}`"
                ></i
                >{{ contents.data.page.locale.buttonLabel }}</a
              >
              <!--end::Action-->
            </div>
            <!--end::Wrapper-->
            <!--begin::Wrapper-->
            <div
              class="flex-equal d-flex align-self-center justify-content-end align-items-center order-0 order-md-1"
            >
              <!--begin::Illustration-->
              <img
                :src="`${backendHost}/images/themes/${contentTheme}/${
                  $store.state.sidebar[contents.name].routeImage
                }`"
                alt=""
                class="mw-100 min-h-100px mh-md-125px mh-lg-225pxs"
              />
              <!--end::Illustration-->
            </div>
            <!--end::Wrapper-->
          </div>
          <!--end::Hero content-->
        </div>
        <!--end::Hero body-->
      </div>
      <!--end::Hero card-->
      <div v-if="dataIsEmpty" class="card-body p-20">
        <div class="d-flex flex-center">
          <img
            class="col-md-3"
            :src="`/assets/images/svg/no_data.svg`"
            alt=""
          />
        </div>
      </div>
      <!--begin::Row-->
      <div v-else>
        <!--begin::Col-->
        <div class="row gap-5 justify-content-between" v-if="$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47'">
          <div v-for="(blog, index) in blogs" :key="index" class="col-md-5 mt-5 mt-md-0">
            <!--begin::Card-->
            <div class="ribbon ribbon-top ribbon-vertical">
            <a
              class="ribbon-label fw-bolder"
              >{{blog.blogPublish ? "Published" : "Unpublished"}}<span class="ribbon-inner rounded-bottom" :class="blog.blogPublish ? 'bg-success' : 'bg-danger'"></span
            ></a>
            <a
              v-if="$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47'"
              class="ribbon-label fw-bolder" style="margin-inline-end:100px">
              {{JSON.parse(blog.blogBody)[0] && typeof JSON.parse(blog.blogBody)[0] == 'object' && JSON.parse(blog.blogBody)[0].renderStatus ? "Rendered" : "In queue"}}
              <span class="ribbon-inner rounded-bottom" :class="JSON.parse(blog.blogBody)[0] && typeof JSON.parse(blog.blogBody)[0] == 'object' && JSON.parse(blog.blogBody)[0].renderStatus ? 'bg-success' : 'bg-warning'"></span
            ></a>
            <!-- <a
              v-if="$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47'"
              class="ribbon-label fw-bolder" style="margin-inline-end:200px">
              {{JSON.parse(blog.blogBody)[0] && typeof JSON.parse(blog.blogBody)[0] == 'object' && JSON.parse(blog.blogBody)[0].renderStatus && blog.blogPublish ? "Accepted" : JSON.parse(blog.blogBody)[0].renderStatus && !blog.blogPublish ? "Under Review" : !JSON.parse(blog.blogBody)[0].renderStatus && blog.blogPublish ? "In review" : "Decline"}}
              <span class="ribbon-inner rounded-bottom" :class="JSON.parse(blog.blogBody)[0] && typeof JSON.parse(blog.blogBody)[0] == 'object' && JSON.parse(blog.blogBody)[0].renderStatus && blog.blogPublish ? 'bg-success' : (JSON.parse(blog.blogBody)[0] && typeof JSON.parse(blog.blogBody)[0] == 'object' && JSON.parse(blog.blogBody)[0].renderStatus && !blog.blogPublish) || (JSON.parse(blog.blogBody)[0] && typeof JSON.parse(blog.blogBody)[0] == 'object' && !JSON.parse(blog.blogBody)[0].renderStatus && blog.blogPublish) ? 'bg-warning' : 'bg-danger'"></span
            ></a> -->
          </div>
            <div class="card overlay overflow-hidden overlay-show">
              <div class="card-body p-0">
                <div class="overlay-wrapper">
                  <div class="blog__template-img">
                    <!--begin::Image-->
                    <div
                      class="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded h-200px"
                      :style="`
                          background-image: url(${backendHost}/uploads/${
                        $store.state.uploadsPath
                      }/test.png;`"
                    ></div>
                    <!--end::Image-->
                  </div>
                </div>
                <div
                  class="overlay-layer flex-column align-items-stretch justify-content-between bg-dark bg-opacity-50 p-5"
                >
                  <div class="text-white mt-3 px-2">
                    <i class="bi bi-eye-fill text-white me-1"></i>
                    <span>2.1k</span>
                  </div>
                  <div
                    class="d-flex flex-column text-center justify-content-center"
                  >
                    <div
                      class="col text-white fw-bold fs-3 mb-5 turncating"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      >
                      <!-- :title="JSON.parse(blog.blogBody).title" -->
                      <!-- {{ JSON.parse(blog.blogBody).title ? JSON.parse(blog.blogBody).title : JSON.parse(blog.blogBody)[0].outputFileName }}
                       -  -->
                      {{ blog.blogSummary }}
                    </div>
                    <div class="col d-flex">
                      <!-- <button
                        @click="setModalConfigs('preview', index)"
                        class="col btn btn-sm btn-primary btn-shadow"
                        >{{ contents.data.page.card.buttons[0].label }}</button
                      > -->
                      <a
                        :href="`${backendHost}/blog/r/${blog.id}?pid=vidisci&locale=${blog.blogLocale}`" target="_blank"
                        class="col btn btn-sm btn-primary btn-shadow ms-2"
                        >{{ contents.data.page.card.buttons[0].label }}</a
                      >
                      <a
                        @click="setModalConfigs('update', index)"
                        class="col btn btn-sm btn-light-primary btn-shadow ms-2"
                        >{{ contents.data.page.card.buttons[1].label }}</a
                      >
                      <a
                        @click="setModalConfigs('delete', index)"
                        class="col btn btn-sm btn-light-danger btn-shadow ms-2"
                        >{{ contents.data.page.card.buttons[2].label }}</a
                      >
                    </div>
                  </div>
                  <div class="d-flex text-white mb-3 flex-center flex-stack">
                    <div class="">
                      <a
                        href="#"
                        class="d-flex align-items-center text-white text-decoration-none"
                      >
                        <i class="bi bi-person-circle text-white me-2"></i>
                        <div
                          class="turncating"
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          :title="`${blog.profileFullName}`"
                        >
                          {{ blog.profileFullName }}
                        </div></a
                      >
                    </div>
                    <div class="d-flex">
                      <span class="text-white mx-1">On</span>
                      <div
                        class="fw-semiBold text-white"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        :title="``"
                      >
                        {{
                          new Date(blog.blogDate).toLocaleDateString(
                            routeLocale,
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            }
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <!-- <div class="d-flex">
                    <div class="text-white position-absolute top-0 mt-3 px-2">
                      <i class="bi bi-eye-fill text-white me-1"></i>
                      <span>2.1k</span>
                    </div>
                    <div class="row text-center justify-content-center">
                      <div
                        class="text-white fw-bold fs-3 mb-5 turncating w-250px w-md-300px"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        :title="JSON.parse(blog.blogBody).title"
                      >
                        {{ JSON.parse(blog.blogBody).title }}
                      </div>
                      <div class="col-12">
                        <a
                          @click="setModalConfigs('show', index)"
                          class="btn btn-sm btn-primary btn-shadow"
                          >{{ contents.data.page.card.buttons[0].label }}</a
                        >
                        <a
                          @click="setModalConfigs('update', index)"
                          class="btn btn-sm btn-light-primary btn-shadow ms-2"
                          >{{ contents.data.page.card.buttons[1].label }}</a
                        >
                        <a
                          @click="deleteBlog(index)"
                          class="btn btn-sm btn-light-danger btn-shadow ms-2"
                          >{{ contents.data.page.card.buttons[2].label }}</a
                        >
                      </div>
                    </div>
                    <div
                      class="d-flex text-white position-absolute bottom-0 mb-3 flex-center"
                    >
                      <div class="d-flex">
                        <a
                          href="#"
                          class="col-5 col-lg-6 d-flex align-items-center text-white text-decoration-none"
                        >
                          <i class="bi bi-person-circle text-white me-2"></i>
                          <div
                            class="turncating"
                            data-bs-toggle="tooltip"
                            data-bs-placement="bottom"
                            title="BehzadRoohparvar"
                          >
                            BehzadRoohparvar
                          </div></a
                        >
                        <div class="col-8 d-flex">
                          <span class="text-white mx-1">On</span>
                          <div
                            class="fw-semiBold text-white"
                            data-bs-toggle="tooltip"
                            data-bs-placement="bottom"
                            title="2022-05-13, 4:42:46 p.m."
                          >
                            2022-05-13, 4:42:46 p.m.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <!--end::Card-->
          </div>
        </div>
        <div
          v-else-if="pac"
          class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-5 g-xl-9"
        >
          <div
            v-for="(product, index) in products"
            :key="index"
            class="col d-flex align-items-stretch"
          >
            <!--begin::Card-->
            <div class="card w-100">
              <!--begin::Card body-->
              <div class="card-body pb-0 d-flex flex-column">
                <div class="mb-6">
                  <a
                    href="#"
                    class="text-inverse-light bg-light text-hover-inverse-secondary bg-hover-secondary rounded fw-bold p-2 fs-8"
                    >{{ product.categoryName }}</a
                  >
                </div>
                <!--begin::Image-->
                <div class="d-flex justify-content-center mb-5">
                  <div
                    :id="`carouselExampleIndicators${index}`"
                    class="carousel slide"
                    data-bs-ride="carousel"
                  >
                    <div class="carousel-indicators color-dark">
                      <button
                        v-for="(photo, bid) in product.productPhotos"
                        :key="bid"
                        type="button"
                        :data-bs-target="`#carouselExampleIndicators${index}`"
                        :data-bs-slide-to="`${bid}`"
                        :class="bid == 0 ? `active` : ''"
                        :aria-current="bid == 0 ? true : null"
                        :aria-label="`Slide ${Number(bid) + 1}`"
                      ></button>
                    </div>
                    <div class="carousel-inner">
                      <div
                        v-for="(photo, pid) in product.productPhotos"
                        :key="photo"
                        :class="pid == 0 ? 'active' : ''"
                      >
                        <div
                          class="symbol symbol-200px"
                          style="background-color: #cccc"
                        >
                          <!-- {{ photo }} -->
                          <img
                            :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                            class="d-block card-image img w-325px"
                            :alt="`${photo}`"
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      class="carousel-control-prev"
                      type="button"
                      :data-bs-target="`#carouselExampleIndicators${index}`"
                      data-bs-slide="prev"
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button
                      class="carousel-control-next"
                      type="button"
                      :data-bs-target="`#carouselExampleIndicators${index}`"
                      data-bs-slide="next"
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div>
                </div>
                <!--end::Image-->
                <!--begin::Title-->
                <a
                  :href="`${backendHost}/shop/r/${product.id}?locale=${routeLocale}`"
                  class="fs-4 text-gray-800 text-hover-primary fw-bold mb-1"
                  target="_blank"
                  >{{ product.productName }}</a
                >
                <!--begin::Summary-->
                <div class="text-gray-500 mb-3 text_justify fs-7">
                  {{ product.productSummary }}
                </div>
                <!--end::Summary-->
                <!--end::Title-->
                <!--begin::Position-->
                <div class="d-flex flex-stack mb-3">
                  <div class="text-gray-500">
                    <i class="bi bi-star-fill text-warning me-1"> </i>
                    <span class="fs-8">{{ product.productRate }}</span>
                  </div>
                  <div class="text-gray-500">
                    <i class="bi bi-people me-1"></i>
                    {{ product.productStudents }}
                  </div>
                </div>
                <div class="d-flex flex-stack mb-3">
                  <div class="text-gray-500">
                    <i class="bi bi-clock me-1"> </i>
                    {{ product.productDuration }}
                  </div>
                  <div class="text-gray-500">
                    <i class="bi bi-book me-1"> </i>
                    {{ product.productSessionsNo }}
                  </div>
                </div>
                <!--end::Position-->
              </div>
              <div class="card-footer py-3 d-flex flex-column">
                <div class="d-flex flex-stack mb-5">
                  <a
                    href=""
                    class="symbol symbol-circle symbol-30px text-dark text-hover-primary fs-8"
                  >
                    <img
                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${product.profilePhoto}`"
                      class="me-1"
                      :alt="`${product.userUserName} photo`"
                    />
                    <span class="ms-1">{{ product.profileFullName }}</span>
                  </a>
                  <div class="d-flex flex-column">
                    <!-- <span class="text-danger"><del> 596,000 تومان</del></span> -->
                    <span v-if="product.productPrice == 0" class="text-success"
                      >Feel Free</span
                    >
                    <span v-else class="text-success"
                      >{{ product.productPrice }}
                      {{ product.productCurrency }}</span
                    >
                  </div>
                </div>
                <div class="align-self-center">
                  <!-- <a
                    :href="`/role-view?id=${product.id}`"
                    class="btn btn-sm btn-light btn-active-primary my-1 me-2"
                    >{{ contents.data.page.card.buttons[0].label }}</a
                  > -->
                  <!-- <button
                    type="button"
                    class="btn btn-sm btn-light btn-active-light-primary my-1 me-2"
                    @click="setModalConfigs('update', index)"
                  >
                    {{ contents.data.page.card.buttons[1].label }}
                  </button> -->
                  <!-- <button
                    type="button"
                    class="btn btn-sm btn-light btn-active-light-danger my-1"
                    data-bs-toggle="modal"
                    data-bs-target="#kt_modal_update_role"
                    @click="setModalConfigs('delete', index)"
                  >
                    {{ contents.data.page.card.buttons[2].label }}
                  </button> -->
                </div>
              </div>
              <!--end::Card body-->
            </div>
            <!--end::Card-->
          </div>
        </div>
        <div
          v-else
          class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-5 g-xl-9"
        >
          <div
            v-for="(product, index) in products"
            :key="index"
            class="col d-flex align-items-stretch"
          >
            <!--begin::Card-->
            <div class="card w-100">
              <!--begin::Card body-->
              <div class="card-body pb-0 d-flex flex-column">
                <div class="mb-6 d-flex flex-stack">
                  <a
                    href="#"
                    class="text-primary bg-light-primary text-hover-inverse-secondary bg-hover-secondary rounded fw-bold p-2 fs-8 me-2"
                    >{{ product.categoryName }}</a
                  >
                  <div class="d-flex gap-2">
                    <a
                      v-for="tag in product.productTags"
                      :key="tag.id"
                      :href="`#${tag.id}`"
                      class="text-inverse-light bg-light text-hover-inverse-secondary bg-hover-secondary rounded fw-bold p-2 fs-8"
                      >{{ tag.tagName }}</a
                    >
                  </div>
                </div>
                <!--begin::Image-->
                <div class="d-flex justify-content-center mb-5">
                  <div
                    :id="`carouselExampleIndicators${index}`"
                    class="carousel slide"
                    data-bs-ride="carousel"
                  >
                    <div class="carousel-indicators">
                      <button
                        v-for="(photo, bid) in product.productPhotos"
                        :key="bid"
                        type="button"
                        :data-bs-target="`#carouselExampleIndicators${index}`"
                        :data-bs-slide-to="`${bid}`"
                        :class="bid == 0 ? `active` : ''"
                        :aria-current="bid == 0 ? true : null"
                        :aria-label="`Slide ${Number(bid) + 1}`"
                      ></button>
                    </div>
                    <div class="carousel-inner">
                      <div
                        v-for="(photo, pid) in product.productPhotos"
                        :key="photo"
                        class="carousel-item"
                        :class="pid == 0 ? 'active' : ''"
                      >
                        <div
                          class="symbol symbol-200px"
                          style="background-color: #cccc"
                        >
                          <img
                            v-if="['png', 'jpg', 'jpeg', 'webp'].indexOf(photo.split('.')[1].toLowerCase()) != -1"
                            :src="`${backendHost}/uploads/${
                              $store.state.uploadsPath
                            }/${encodeURIComponent(photo)}`"
                            class="d-block card-image img mw-350px"
                            :alt="`${photo} ${encodeURIComponent(photo)}`"
                          />
                          <video 
                            v-else-if="['mp4', 'avi'].indexOf(photo.split('.')[1]) != -1"
                            :src="`${backendHost}/uploads/${
                              $store.state.uploadsPath
                            }/${encodeURIComponent(photo)}`"
                            class="d-block card-image img mw-350px"
                          ></video>
                        </div>
                      </div>
                    </div>
                    <button
                      class="carousel-control-prev"
                      type="button"
                      :data-bs-target="`#carouselExampleIndicators${index}`"
                      data-bs-slide="prev"
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button
                      class="carousel-control-next"
                      type="button"
                      :data-bs-target="`#carouselExampleIndicators${index}`"
                      data-bs-slide="next"
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div>
                </div>
                <!--end::Image-->
                <!--begin::Title-->
                <a
                  :href="`${backendHost}/shop/r/${product.id}?locale=${routeLocale}`"
                  class="fs-4 text-gray-800 text-hover-primary fw-bold mb-1"
                  target="_blank"
                  >{{ product.productName }}</a
                >
                <!--begin::Summary-->
                <div class="text-gray-500 mb-3 text_justify fs-7">
                  {{ product.productSummary }}
                </div>
                <!--end::Summary-->
                <!--end::Title-->
                <!--begin::Position-->
                <div class="d-flex flex-stack mb-3">
                  <div class="text-gray-500">
                    <i class="bi bi-calendar me-1"> </i>
                    {{ product.productDate }}
                  </div>
                  <div class="text-gray-500">
                    <i class="bi bi-star-fill text-warning me-1"> </i>
                    <span class="fs-8">{{ product.productRate }}</span>
                  </div>
                </div>
                <!--end::Position-->
              </div>
              <div class="card-footer py-3 d-flex flex-column">
                <div class="d-flex flex-stack mb-5">
                  <a
                    href=""
                    class="symbol symbol-circle symbol-30px text-dark text-hover-primary fs-8"
                  >
                    <img
                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${product.profilePhoto}`"
                      class="me-1"
                      :alt="`${product.userUserName} photo`"
                    />
                    <span class="ms-1">{{ product.profileFullName }}</span>
                  </a>
                  <div class="d-flex flex-column text-end">
                    <!-- <span class="text-danger"><del> 596,000 تومان</del></span> -->
                    <span v-if="product.productPrice == 0" class="text-success"
                      >Free</span
                    >
                    <div v-else class="d-flex flex-column">
                      <div v-if="product.productOff > 0">
                        <span class="text-danger"
                          ><del
                            >{{ product.productPrice }}
                            {{ product.productCurrency }}</del
                          ></span
                        >
                        <span class="text-success"
                          >{{ product.productPrice }}
                          {{ product.productCurrency }}</span
                        >
                      </div>
                      <div v-else>
                        <span class="text-success"
                          >{{ product.productPrice }}
                          {{ product.productCurrency }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="align-self-center">
                  <!-- <a
                    :href="`/${routeLocale}/productview/${product.id}`"
                    class="btn btn-sm btn-light btn-active-primary my-1 me-2"
                    >{{ contents.data.page.card.buttons[0].label }}</a
                  > -->
                  <button
                    type="button"
                    class="btn btn-sm btn-light btn-active-primary my-1 me-2"
                    @click="setModalConfigs('view', product)"
                  >
                    {{ contents.data.page.card.buttons[0].label }}
                  </button>
                  <!-- <button
                    type="button"
                    class="btn btn-sm btn-light btn-active-light-primary my-1 me-2"
                    @click="setModalConfigs('update', index)"
                  >
                    {{ contents.data.page.card.buttons[1].label }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-light btn-active-light-danger my-1"
                    data-bs-toggle="modal"
                    data-bs-target="#kt_modal_update_role"
                    @click="setModalConfigs('delete', index)"
                  >
                    {{ contents.data.page.card.buttons[2].label }}
                  </button> -->
                </div>
              </div>
              <!--end::Card body-->
            </div>
            <!--end::Card-->
          </div>
        </div>
        <div v-if="totalPages > 1" class="w-100 text-center mt-5">
          <pagination
            :pages="totalPages"
            v-model="currentPage"
            @update:modelValue="setCurrentPage"
          ></pagination>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->
      <!--begin::Modals-->
      <create-update
        v-if="modalDisplay"
        :stepType="stepType"
        :contents="contents.data.modal"
        :modalInfo="productInfo"
        :mode="mode"
        :modalType="'uploadselect'"
        :firstErrorName="firstErrorName"
        @close-modal="setModalConfigs"
      ></create-update>
      <dialog-box
        v-if="dialogDisplay"
        :contents="contents.data.modal"
        :modalInfo="deleteInfo"
        @close-modal="setModalConfigs"
      >
      </dialog-box>
      <preview
        v-if="viewDisplay"
        :contents="contents.data.modal"
        :modalInfo="productInfo"
        @close-modal="setModalConfigs"
      >
      </preview>
      <!--end::Modals-->
    </div>
    <!--end::Container-->
  </div>
</template>

<script>
import dataService from "../../../services/data";
import serverConfigs from "../../../configs/server.json";

// Tools
import Pagination from "../../tools/Pagination.vue";

// Modals
import CreateUpdate from "../../modals/CreateUpdate.vue";
import DialogBox from "../../modals/DialogBox.vue";
import Preview from "../../modals/Preview.vue";

export default {
  components: {
    Pagination,
    CreateUpdate,
    DialogBox,
    Preview
  },
  setup() {},
  computed: {
    contentTheme() {
      return this.$store.state.themeFile.replace(".css", "");
    },
    backendHost() {
      return serverConfigs["serverDomain"]["host"];
    },
    routeLocale() {
      return this.$route.params.locale;
    },
    bodyNode() {
      return document.getElementById("kt_body");
    },
    templateIndex() {
      let index = "";
      for (let b in this.contents.data.modal.fields[0].options) {
        console.log(this.contents.data.modal.fields[0].options)
        if (
          this.contents.data.modal.fields[0].options[b].value ==
          this.blogInfo["blogTemplate"]
        ) {
          index = b;
        }
      }
      
      return index;
    },
  },
  data() {
    return {
      viewDisplay: false,
      totalPages: 0,
      currentPage: 1,
      pac: false,
      productInfo: {},
      deleteInfo: Object,
      modalDisplay: false,
      dialogDisplay: false,
      dataIsEmpty: true,
      blogs: [],
      blogInfo: {},
      products: [],
      purchaseProducts: [],
      firstErrorName: "",
      contents: {
        name: "",
        data: {},
        status: false,
      },
      mode: "multi",
      stepType: null,
      loaderStatus: [false, false, false, false],
    };
  },
  methods: {
    setModalConfigs(opt, index) {
      // this.$store.commit("setLoader", true);
      switch (opt) {
        case "update":
          if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47') {
            this.productInfo = { ...this.blogs[index], status: false }
            this.blogInfo = this.productInfo
            console.log(this.templateIndex)
            console.log(this.contents.data.modal.fields[0].options)
            this.setupBlogBody(
              this.blogInfo,
                this.contents.data.modal.fields[0].options[this.templateIndex].fields
            );
          } else {
            this.productInfo = { ...this.products[index], status: false };
            this.productInfo["photos"] = this.products[index].productPhotos;
          }
          
          this.modalDisplay = !this.modalDisplay;
          this.$store.commit("setLoader", false);

          break;
        case "create":
          if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47') {
            this.setupBlogInfo();
          } else {
            this.setupProductInfo();
          }
          this.modalDisplay = !this.modalDisplay;
          this.$store.commit("setLoader", false);

          break;
        case "delete":
          this.deleteInfo = {
            id: this.products[index].id,
            name: this.products[index].productName,
            status: true,
            delete: true,
          };
          this.dialogDisplay = !this.dialogDisplay;
          this.$store.commit("setLoader", false);

          break;
        case "validate":
          if (index.delete) {
            this.deleteProducts(index);
          } else {
            console.log(index.id)
            // index["productPhotos"] = index["photos"];
            // if (this.inputValidation(index)) {
            if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47') {
              index.id ? this.updateBlogs(index) : this.createBlogs(index);
            } else {
              index.id ? this.updateProducts(index) : this.createProducts(index);
            }
            // } else {
            //   this.$store.commit("setLoader", false);
            // }
          }
          break;
        case "view":
          this.$store.commit("setCurProduct", index);
          
          this.$store.commit("setLoader", false);
          
          this.$router.push(`productview/${index.id}`)
          break;
        case "preview":
          if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47') {
            Object.assign(this.productInfo, this.blogs[index])
            // this.productInfo = this.blogs[index]
            this.blogInfo = this.productInfo
            this.productInfo['blogBody'] = JSON.parse(this.productInfo['blogBody'])
          } else {
            this.productInfo = { ...this.products[index], status: false };
            this.productInfo["photos"] = this.products[index].productPhotos;
          }
          
          this.viewDisplay = !this.viewDisplay;
          this.$store.commit("setLoader", false);

          break;
        default:
          this.modalDisplay = false;
          this.viewDisplay = false;
          this.resetProductInfo();
          this.$store.commit("setLoader", false);

          break;
      }
    },
    setupBlogBody(obj) {
      console.log(obj)
      let tempBody = {};
      Object.assign(tempBody, JSON.parse(obj["blogBody"]));
      obj["blogBody"] = [];
      for (let field in this.contents.data.modal.fields[0].options) {
        if (
          this.contents.data.modal.fields[0].options[field].fields != undefined
        ) {
          obj["blogBody"].push(
            this.contents.data.modal.fields[0].options[field].fields
          );
        }
      }
      for (let field in obj["blogBody"][`${this.templateIndex}`].fields) {
        obj["blogBody"][`${this.templateIndex}`].fields[field]["value"] =
          tempBody[
            `${obj["blogBody"][`${this.templateIndex}`].fields[field].name}`
          ];
      }
      // obj["photos"] = [
      //   tempBody[`${obj["blogBody"][`${this.templateIndex}`].fields[0].name}`],
      // ];
      obj["photos"] = tempBody[`${obj["blogBody"][`${this.templateIndex}`].fields[0].name}`].split(",")
    },
    setCurrentPage(page) {
      this.$store.commit("setLoader", true);
      this.readProducts(page);
    },
    loaderDone() {
      if (
        this.loaderStatus[0] &&
        this.loaderStatus[1] &&
        this.loaderStatus[2] &&
        this.loaderStatus[3]
      ) {
        this.$store.commit("setLoader", false);
      }
    },
    getContents() {
      let tempName = this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47' ?
        "blogs" : "products"
      let data = {
        endPoint: `contents/r/${tempName}_client`,
        locale: `${this.routeLocale}`,
        data: {},
      };

      dataService
        .get(data)
        .then((res) => {
          this.contents = {
            name: res.data.data[0].contentName,
            data: res.data.data[0].contentJson,
            status: true,
          };

          this.contents.data.modal.fields = this.$store.state.shopType.includes(
            "->"
          )
            ? this.contents.data.modal.fields[
                this.$store.state.shopType.split("->")[0]
              ][this.$store.state.shopType.split("->")[1]]
            : this.contents.data.modal.fields[this.$store.state.shopType];
          if (this.$store.state.shopType.split("->")[1] == "hafezli") {
            this.stepType = "wizard";
          }

          if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47') {
            this.readPurchasableProducts(1);
            this.readCategories();
            this.readTags();
            this.readBlogs();
          }
        })
        .catch((error) => {
          console.log(error)
          this.$notify({
            type: error.response && error.response.data ? error.response.data.type : 'error',
            title: error.response && error.response.data ? error.response.data.type : 'Error',
            text: error.response && error.response.data ? error.response.data.message : error,
          });
        })
        .finally(() => {
          this.loaderStatus[0] = true;
          this.loaderDone();
        });
    },
    setupProductInfo() {
      let rootCard = {};
      let childCard = {};
      for (let counter in this.contents.data.modal.fields) {
        switch (this.contents.data.modal.fields[counter].type) {
          case "text":
            this.productInfo[this.contents.data.modal.fields[counter].name] =
              "";
            break;
          case "textarea":
            this.productInfo[this.contents.data.modal.fields[counter].name] =
              "";
            break;
          case "card":
            Object.assign(
              rootCard,
              this.contents.data.modal.fields[counter].value
            );
            this.productInfo[this.contents.data.modal.fields[counter].name] = [
              rootCard,
            ];
            for (let i in this.contents.data.modal.fields[counter].fields) {
              switch (this.contents.data.modal.fields[counter].fields[i].type) {
                case "text":
                  this.productInfo[
                    this.contents.data.modal.fields[counter].fields[i].name
                  ] = "";
                  break;
                case "textarea":
                  this.productInfo[
                    this.contents.data.modal.fields[counter].fields[i].name
                  ] = "";
                  break;
                case "card":
                  Object.assign(
                    childCard,
                    this.contents.data.modal.fields[counter].fields[i].value
                  );
                  this.productInfo[
                    this.contents.data.modal.fields[counter].fields[i].name
                  ] = [childCard];
                  break;
                default:
                  break;
              }
            }
            break;
          default:
            break;
        }
      }
      this.productInfo["status"] = true;
    },
    resetProductInfo() {
      this.productInfo = {};
      this.modalDisplay = false;
      this.dialogDisplay = false;
      if (!this.modalDisplay) {
        this.bodyNode.classList.remove("modal-open");
        this.bodyNode.style.overflow = "visible";
      }
      for (let index in this.contents.data.modal.fields) {
        if (this.contents.data.modal.fields[index].required) {
          this.contents.data.modal.fields[index].errorCode = 0;
        }
      }
    },
    inputValidation(obj) {
      let errorCount = 0;
      let tempError = "";

      for (
        let index = 0;
        index < this.contents.data.modal.fields.length;
        index++
      ) {
        // if (this.contents.data.modal.fields[index].type == "card") {
        //   for (
        //     let i = 0;
        //     i < this.contents.data.modal.fields[index].fields.length;
        //     i++
        //   ) {
        //     for (let p in obj[this.contents.data.modal.fields[index].name]) {
        //       if (
        //         this.contents.data.modal.fields[index].fields[i].type == "card"
        //       ) {
        //         for (
        //           let j = 0;
        //           j <
        //           this.contents.data.modal.fields[index].fields[i].fields
        //             .length;
        //           j++
        //         ) {
        //           if (
        //             this.contents.data.modal.fields[index].fields[i].fields[j]
        //               .required
        //           ) {
        //             console.log(obj[this.contents.data.modal.fields[index].name][p][
        //                     this.contents.data.modal.fields[index].fields[i].name
        //                   ])
        //                   console.log(this.contents.data.modal.fields[index].fields[i].name)
        //             // for (let s in obj[
        //             //   this.contents.data.modal.fields[index].fields[i].name
        //             // ]) {
        //             //   // for (let expression in this.contents.data.modal.fields[
        //             //   //   index
        //             //   // ].fields[i].fields[j].validation) {
        //             //   //   switch (
        //             //   //     this.contents.data.modal.fields[index].fields[i]
        //             //   //       .fields[j].validation[expression].expression
        //             //   //   ) {
        //             //   //     case "isEmpty":
        //             //   //       this.contents.data.modal.fields[index].fields[
        //             //   //         i
        //             //   //       ].fields[j].errorCode =
        //             //   //         !obj[this.contents.data.modal.fields[index].name][
        //             //   //           p
        //             //   //         ][
        //             //   //           this.contents.data.modal.fields[index].fields[i]
        //             //   //             .fields[j].name
        //             //   //         ][s] ||
        //             //   //         obj[this.contents.data.modal.fields[index].name][
        //             //   //           s
        //             //   //         ][
        //             //   //           this.contents.data.modal.fields[index].fields[i]
        //             //   //             .fields[j].name
        //             //   //         ].length == 0
        //             //   //           ? this.contents.data.modal.fields[index].fields[
        //             //   //               i
        //             //   //             ].validation[expression].id
        //             //   //           : 0;
        //             //   //       if (
        //             //   //         this.contents.data.modal.fields[index].fields[i]
        //             //   //           .errorCode > 0
        //             //   //       ) {
        //             //   //         errorCount += 1;
        //             //   //         tempError =
        //             //   //           tempError.length == 0
        //             //   //             ? this.contents.data.modal.fields[index]
        //             //   //                 .fields[i].name
        //             //   //             : tempError;
        //             //   //       }
        //             //   //       break;
        //             //   //     case "isSpace":
        //             //   //       this.contents.data.modal.fields[index].fields[
        //             //   //         i
        //             //   //       ].errorCode =
        //             //   //         this.contents.data.modal.fields[index].fields[i]
        //             //   //           .validation.length > 1 &&
        //             //   //         this.contents.data.modal.fields[index].fields[i]
        //             //   //           .errorCode > 0
        //             //   //           ? this.contents.data.modal.fields[index].fields[
        //             //   //               i
        //             //   //             ].errorCode
        //             //   //           : String(
        //             //   //               obj[
        //             //   //                 this.contents.data.modal.fields[index]
        //             //   //                   .name
        //             //   //               ][p][
        //             //   //                 this.contents.data.modal.fields[index]
        //             //   //                   .fields[i].name
        //             //   //               ]
        //             //   //             ).trim().length == 0
        //             //   //           ? this.contents.data.modal.fields[index].fields[
        //             //   //               i
        //             //   //             ].validation[expression].id
        //             //   //           : 0;
        //             //   //       if (
        //             //   //         this.contents.data.modal.fields[index].fields[i]
        //             //   //           .errorCode > 0
        //             //   //       ) {
        //             //   //         errorCount += 1;
        //             //   //         tempError =
        //             //   //           tempError.length == 0
        //             //   //             ? this.contents.data.modal.fields[index]
        //             //   //                 .fields[i].name
        //             //   //             : tempError;
        //             //   //       }
        //             //   //       break;
        //             //   //     default:
        //             //   //       this.contents.data.modal.fields[
        //             //   //         index
        //             //   //       ].errorCode = 0;
        //             //   //       break;
        //             //   //   }
        //             //   // }
        //             // }
        //           }
        //         }
        //       } else {
        //         if (this.contents.data.modal.fields[index].fields[i].required) {
        //           for (let expression in this.contents.data.modal.fields[index]
        //             .fields[i].validation) {
        //             switch (
        //               this.contents.data.modal.fields[index].fields[i]
        //                 .validation[expression].expression
        //             ) {
        //               case "isEmpty":
        //                 this.contents.data.modal.fields[index].fields[
        //                   i
        //                 ].errorCode =
        //                   !obj[this.contents.data.modal.fields[index].name][p][
        //                     this.contents.data.modal.fields[index].fields[i]
        //                       .name
        //                   ] ||
        //                   obj[this.contents.data.modal.fields[index].name][p][
        //                     this.contents.data.modal.fields[index].fields[i]
        //                       .name
        //                   ].length == 0
        //                     ? this.contents.data.modal.fields[index].fields[i]
        //                         .validation[expression].id
        //                     : 0;
        //                 if (
        //                   this.contents.data.modal.fields[index].fields[i]
        //                     .errorCode > 0
        //                 ) {
        //                   errorCount += 1;
        //                   tempError =
        //                     tempError.length == 0
        //                       ? this.contents.data.modal.fields[index].fields[i]
        //                           .name
        //                       : tempError;
        //                 }
        //                 break;
        //               case "isSpace":
        //                 this.contents.data.modal.fields[index].fields[
        //                   i
        //                 ].errorCode =
        //                   this.contents.data.modal.fields[index].fields[i]
        //                     .validation.length > 1 &&
        //                   this.contents.data.modal.fields[index].fields[i]
        //                     .errorCode > 0
        //                     ? this.contents.data.modal.fields[index].fields[i]
        //                         .errorCode
        //                     : String(
        //                         obj[
        //                           this.contents.data.modal.fields[index].name
        //                         ][p][
        //                           this.contents.data.modal.fields[index].fields[
        //                             i
        //                           ].name
        //                         ]
        //                       ).trim().length == 0
        //                     ? this.contents.data.modal.fields[index].fields[i]
        //                         .validation[expression].id
        //                     : 0;
        //                 if (
        //                   this.contents.data.modal.fields[index].fields[i]
        //                     .errorCode > 0
        //                 ) {
        //                   errorCount += 1;
        //                   tempError =
        //                     tempError.length == 0
        //                       ? this.contents.data.modal.fields[index].fields[i]
        //                           .name
        //                       : tempError;
        //                 }
        //                 break;
        //               default:
        //                 this.contents.data.modal.fields[index].errorCode = 0;
        //                 break;
        //             }
        //           }
        //         }
        //       }
        //     }
        //   }
        // } else {
        if (this.contents.data.modal.fields[index].required) {
          for (let expression in this.contents.data.modal.fields[index]
            .validation) {
            switch (
              this.contents.data.modal.fields[index].validation[expression]
                .expression
            ) {
              case "isEmpty":
                this.contents.data.modal.fields[index].errorCode =
                  !obj[this.contents.data.modal.fields[index].name] ||
                  obj[this.contents.data.modal.fields[index].name].length == 0
                    ? this.contents.data.modal.fields[index].validation[
                        expression
                      ].id
                    : 0;
                if (this.contents.data.modal.fields[index].errorCode > 0) {
                  errorCount += 1;
                  tempError =
                    tempError.length == 0
                      ? this.contents.data.modal.fields[index].name
                      : tempError;
                }
                break;
              case "isSpace":
                this.contents.data.modal.fields[index].errorCode =
                  this.contents.data.modal.fields[index].validation.length >
                    1 && this.contents.data.modal.fields[index].errorCode > 0
                    ? this.contents.data.modal.fields[index].errorCode
                    : String(
                        obj[this.contents.data.modal.fields[index].name]
                      ).trim().length == 0
                    ? this.contents.data.modal.fields[index].validation[
                        expression
                      ].id
                    : 0;
                if (this.contents.data.modal.fields[index].errorCode > 0) {
                  errorCount += 1;
                  tempError =
                    tempError.length == 0
                      ? this.contents.data.modal.fields[index].name
                      : tempError;
                }
                break;
              default:
                this.contents.data.modal.fields[index].errorCode = 0;
                break;
            }
          }
        }
        // }
      }
      this.firstErrorName =
        tempError.length > 0 ? tempError : this.firstErrorName;
      return errorCount == 0 ? true : false;
    },
    inputValidation_new(obj) {
      let errorCount = 0;
      let tempItem = {};

      let tempStep = this.contents.data.modal.fields;
      for (let i in tempStep) {
        if (
          tempStep[i].type == "tab" ||
          tempStep[i].type == "radioTab" ||
          tempStep[i].type == "imgRadio" ||
          tempStep[i].type == "mulImgRadio"
        ) {
          tempItem = tempStep[i].tabs[this.registerInfo[tempStep[i].key]].rows;
        } else {
          tempItem = tempStep;
        }
      }
      for (let i in tempItem) {
        if (tempItem[i].required) {
          for (let v in tempItem[i].validation) {
            switch (tempItem[i].validation[v].expression) {
              case "isEmpty":
                tempItem[i].errorCode =
                  !obj[tempItem[i].key] || obj[tempItem[i].key].length == 0
                    ? tempItem[i].validation[v].id
                    : 0;
                if (tempItem[i].errorCode > 0) {
                  errorCount += 1;
                }
                tempItem[i].type == "selectMiniFile"
                  ? null
                  : this.goto(tempItem[i].name);
                break;
              case "isSpace":
                tempItem[i].errorCode =
                  tempItem[i].validation.length > 1 && tempItem[i].errorCode > 0
                    ? tempItem[i].errorCode
                    : String(obj[tempItem[i].name]).trim().length == 0
                    ? tempItem[i].validation[v].id
                    : 0;
                if (tempItem[i].errorCode > 0) {
                  errorCount += 1;
                }
                this.goto(tempItem[i].name);
                break;
              default:
                tempItem[i].errorCode = 0;
                break;
            }
          }
        }
      }
      return errorCount == 0 ? true : false;
    },
    readProducts(id) {
      console.log(id)
      let data = {
        endPoint: `products/r/${id}`,
        pageNo: 1,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          for (let i in res.data.data) {
            res.data.data[i].productDate = new Date(
              res.data.data[i].productDate
            ).toLocaleDateString(this.routeLocale, {
              year: "numeric",
              month: "long",
              day: "numeric",
            });
          }

          this.products.push(res.data.data[0]);
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[2] = true;
          this.loaderDone();
        });
    },
    readInvoices(page) {
      let data = {
        endPoint: `invoices`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
        query: {
          situation: "paid",
        },
      };
      data.query = JSON.stringify(data.query)
        .replace("{", "")
        .replace(",", "&")
        .replace("}", "")
        .replace(/":"/g, "=")
        .replace(/"/g, "");
      dataService
        .get(data)
        .then((res) => {
          if (res.data.data.length > 0) {
            this.dataIsEmpty = false
          } else {
            this.dataIsEmpty = true
            this.loaderStatus[2] = true;
          }

          for (let i in res.data.data) {
            this.readProducts(res.data.data.data[i]['invoiceCart'][0]['id'])
          }
        })
        .catch((error) => {
          this.$notify({
            type: error.response && error.response.data ? error.response.data.type : 'error',
            title: error.response && error.response.data ? error.response.data.type : 'Error',
            text: error.response && error.response.data ? error.response.data.message : error,
          });
          this.loaderStatus[2] = true;
        })
        .finally(() => {
          this.loaderStatus[1] = true;
          this.loaderDone();
        });
    },
    readTemplates(obj) {
      console.log(obj.productChapters['id'])
      let data = {
        endPoint: `templates/r/${obj.productChapters['id']}`,
        pageNo: 1,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          console.log(res.data.data)
          let tempTemplates = this.contents.data.modal.fields[0];
          for (let i in res.data.data) {
            tempTemplates.options.push({
              title: obj.productName,
              // value: obj.id,
              value: res.data.data[i].id,
              fields: res.data.data[i].templateSections,
              parse: {
                "poster": obj.productPhotos[0],
                "video": obj.productPhotos[1],
              },
              uploadsPath: true,
              info: {
                price: obj.productPrice,
                category: obj.categoryName,
                tags: obj.productTagsName,
                summary: obj.productSummary,
                description: obj.productReview
              }
            });
          }

          console.log(tempTemplates)
          // for (let i in res.data.data) {
          //   res.data.data[i].productDate = new Date(
          //     res.data.data[i].productDate
          //   ).toLocaleDateString(this.routeLocale, {
          //     year: "numeric",
          //     month: "long",
          //     day: "numeric",
          //   });
          // }

          // this.products.push(res.data.data[0]);
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[2] = true;
          this.loaderDone();
        });
    },
    readPurchasableProducts(page) {
      let data = {
        endPoint: `products`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          console.log(res.data);
          // res.data.data.length > 0
          //   ? (this.dataIsEmpty = false)
          //   : (this.dataIsEmpty = true);
          for (let template in res.data.data) {
            this.readTemplates(res.data.data[template])
          }
          // for (let i in this.purchaseProducts) {
          //   this.purchaseProducts[i].productDate = new Date(
          //     this.purchaseProducts[i].productDate
          //   ).toLocaleDateString(this.routeLocale, {
          //     year: "numeric",
          //     month: "long",
          //     day: "numeric",
          //   });

          //   if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47') {
          //     this.purchaseProducts[i].productChapters = this.purchaseProducts[i].productChapters['id']
          //   }
          // }
          // if (page == 1) {
          //   this.totalPages = res.data.totalRes;
          // }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[3] = true;
          this.loaderDone();
        });
    },
    readCategories() {
      let data = {
        endPoint: `categories`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
        query: {
          category: "Shop",
        },
      };
      data.query = JSON.stringify(data.query)
        .replace("{", "")
        .replace(",", "&")
        .replace("}", "")
        .replace(/":"/g, "=")
        .replace(/"/g, "");

      dataService
        .get(data)
        .then((res) => {
          let tempCategories = {};
          this.contents.data.modal.fields.forEach((field) => {
            if (field.name == "blogCategory") {
              tempCategories = field;
            }
          });
          for (let i in res.data.data) {
            tempCategories.options.push({
              title: res.data.data[i].categoryName,
              value: res.data.data[i].id,
            });
          }
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[2] = true;
          this.loaderDone();
        });
    },
    readTags() {
      let data = {
        endPoint: `tags`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          let tempTags = {};
          this.contents.data.modal.fields.forEach((field) => {
            if (field.name == "blogTags") {
              tempTags = field;
            }
          });
          for (let tag in res.data.data) {
            tempTags.options.push({
              title: res.data.data[tag].tagName,
              value: res.data.data[tag].id,
            });
          }
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[2] = true;
          this.loaderDone();
        });
    },
    setupBlogInfo() {
      for (let counter in this.contents.data.modal.fields) {
        switch (this.contents.data.modal.fields[counter].type) {
          case "text":
            this.productInfo[this.contents.data.modal.fields[counter].name] = "";
            break;
          case "combobox":
            this.productInfo[this.contents.data.modal.fields[counter].name] = [];
            break;
          case "multiselect":
            this.productInfo[this.contents.data.modal.fields[counter].name] = [];
            break;
          case "file":
            this.productInfo[this.contents.data.modal.fields[counter].name] = [];
            break;
          case "imageInput":
            this.productInfo[this.contents.data.modal.fields[counter].name] = [];
            break;
          case "component":
            this.productInfo[this.contents.data.modal.fields[counter].name] = [];
            for (let field in this.contents.data.modal.fields[0].options) {
              if (
                this.contents.data.modal.fields[0].options[field].fields !=
                undefined
              ) {
                this.productInfo[
                  this.contents.data.modal.fields[counter].name
                ].push(
                  this.contents.data.modal.fields[0].options[field].fields
                );
              }
            }
            break;
          default:
            break;
        }
      }
      this.productInfo["status"] = true;
    },
    resetBlogInfo() {
      this.blogInfo = {};
      this.modalDisplay = false;
      this.dialogDisplay = false;
      if (!this.modalDisplay) {
        this.bodyNode.classList.remove("modal-open");
        this.bodyNode.style.overflow = "visible";
      }
      for (let index in this.contents.data.modal.fields) {
        if (this.contents.data.modal.fields[index].required) {
          this.contents.data.modal.fields[index].errorCode = 0;
        }
      }
    },
    createBlogs(obj) {
      console.log(obj)
      this.blogInfo = obj;

      let tempBody = [];
      for (let i in obj["blogBody"][this.templateIndex]) {
        tempBody.push({})
        for (let field in obj["blogBody"][this.templateIndex][i].sectionJson.fields) {
          if (obj["blogBody"][this.templateIndex][i].sectionJson.fields[field].type == 'selectFile' && obj["photos"]) {
            obj["blogBody"][this.templateIndex][i].sectionJson.fields[field]["value"] = obj["photos"].toString();
          }
          tempBody[i][
            `${obj["blogBody"][this.templateIndex][i].sectionJson.fields[field].name}`
          ] = obj["blogBody"][this.templateIndex][i].sectionJson.fields[field].value;
        }
      }
      
      let data = {
        endPoint: `blogs`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {
          template: obj["blogTemplate"],
          // locale: obj["blogLocale"],
          body: tempBody,
          locale: this.routeLocale,
          category: obj["blogCategory"],
          tags: obj["blogTags"],
          summary: obj["blogSummary"],
          publish: obj["blogPublish"],
        },
      };
      dataService
        .post(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: res.data.message,
          });
          this.resetBlogInfo();
          this.readBlogs();
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.$store.commit("setLoader", false);
        });
      },
    readBlogs(page) {
      let data = {
        endPoint: `blogs`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          console.log(res.data)
          res.data.data.length > 0
            ? (this.dataIsEmpty = false)
            : (this.dataIsEmpty = true);
          this.blogs = res.data.data;

          // for (let i in this.blogs) {
          //   this.blogs[i].blogBody["image"] = this.blogs[i].blogBody["image"].split(",")
          // }

          this.blogs = this.blogs.reverse();
          if (page == 0) {
            this.totalPages = res.data.totalRes
          }
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[3] = true;
          this.loaderDone();
        });
    },
    updateBlogs(obj) {
      // obj["blogBody"][`${this.templateIndex}`].fields[0]["value"] =
      //   obj["photos"] && obj["photos"].length > 0
      //     ? obj["photos"].toString()
      //     : obj["blogBody"][`${this.templateIndex}`].fields[0]["value"];
      // let tempBody = {};
      // for (let field in obj["blogBody"][`${this.templateIndex}`].fields) {
      //   tempBody[
      //     `${obj["blogBody"][`${this.templateIndex}`].fields[field].name}`
      //   ] = obj["blogBody"][`${this.templateIndex}`].fields[field].value;
      // }

      let tempBody = {};
      for (let field in obj["blogBody"][this.templateIndex].fields) {
        if (obj["blogBody"][this.templateIndex].fields[field].type == 'selectFile') {
          obj["blogBody"][this.templateIndex].fields[field]["value"] = obj["photos"].toString();
        }
        tempBody[
          `${obj["blogBody"][this.templateIndex].fields[field].name}`
        ] = obj["blogBody"][this.templateIndex].fields[field].value;
      }

      let data = {
        endPoint: `blogs/u/${obj.id}`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {
          template: obj["blogTemplate"],
          // locale: obj["blogLocale"],
          body: tempBody,
          locale: this.routeLocale,
          category: obj["blogCategory"],
          tags: obj["blogTags"],
          summary: obj["blogSummary"],
          publish: obj["blogPublish"],
        },
      };
      
      dataService
        .post(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: res.data.message,
          });
          this.resetBlogInfo();
          this.readBlogs();
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.$store.commit("setLoader", false);
          
        });
    },
    deleteBlogs(obj) {
      this.$store.commit("setLoader", true);
      
      let data = {
        endPoint: `blogs/d/${obj.id}`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: res.data.message,
          });
          this.resetBlogInfo();
          this.readBlogs();
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.$store.commit("setLoader", false);
          
        });
    },
  },
  mounted() {
    this.$store.commit("setLoader", true);
    this.getContents();
    // this.readProducts(1);
    this.readInvoices(1)
  },
};
</script>
